import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SideModalDialogData } from '../../interfaces/dialogs.interface';

@Component({
  selector: 'app-side-modal',
  templateUrl: './side-modal.component.html',
  styleUrls: ['./side-modal.component.scss'],
})
export class SideModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SideModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SideModalDialogData //@Inject(MAT_DIALOG_DATA) //public data: { //  id: string; //  title: string; //  message: string; //  buttonAction: string; //  buttonCancel: string; //} //private readonly dialogRef: MatDialogRef<SideModalComponent>, //private readonly navService: NavigationLibraryService
  ) {}

  onActionProceed(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
